import dayjs from 'dayjs';
import { ChampCompteRendu } from '../compte-rendu/champ-compte-rendu.model';
import { Coordinates } from '../coordinates.model';
import { VerifMateriel } from '../verif-materiel.model';
import { UserEvent } from './user-event.model';

export class DebutVacationGardiennageEvent extends UserEvent {
  public static NAME = 'DEBUT_VACATION_GARDIENNAGE_EVENT';

  constructor(
    public idCreneau: string,
    public idVacation: string,
    public debut: dayjs.Dayjs,
    public verificationMateriel?: VerifMateriel,
    public champsPersonnalises: ChampCompteRendu[] = [],
    public idConsignes: string[] = [],
    coordinates?: Coordinates
  ) {
    super(DebutVacationGardiennageEvent.NAME, undefined, coordinates);
  }

  public static hydrate(obj: DebutVacationGardiennageEvent): DebutVacationGardiennageEvent {
    return new DebutVacationGardiennageEvent(
      obj.idCreneau,
      obj.idVacation,
      dayjs(obj.debut),
      obj.verificationMateriel,
      obj.champsPersonnalises,
      obj.idConsignes,
      obj.coordinates
    );
  }
}
